import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const RegionContext = createContext({
  region: null,
  setRegion() {},
  regionDoc: null,
  setRegionDoc() {}
});

const RegionProvider = ({ children }) => {
  const [region, setRegion] = useState(null);
  const [regionDoc, setRegionDoc] = useState(null);

  return (
    <RegionContext.Provider
      value={{
        region,
        setRegion,
        regionDoc,
        setRegionDoc
      }}
    >
      {children}
    </RegionContext.Provider>
  );
};

RegionProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default RegionProvider;
